export default "__VITE_ASSET__b16a6248__"